import React from "react";
import MenuListItem from "./MenuListItem";

const MenuList = ({ nodes, isFooter = false }) => {
  return nodes.map((item, key) => (
    <MenuListItem item={item} key={key} isFooter={isFooter} />
  ));
};

export default MenuList;
